import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithoutAuthorization, postApiWithoutAuthorization } from "../ApiMethod/ApiMethod";


export const FAQ = async () => {
    const url = `${BaseUrl}/FAQ`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
export const GetFAQListByService = async (ModuleID, SubModuleID) => {
    const url = `${BaseUrl}/GetFAQListByService?ModuleID=${ModuleID}&SubModuleID=${SubModuleID}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
